import ArTheme from "../argon-ui/Theme";
import {
  faUserCog,
  faUserTie,
  faUserClock,
  faUser,
  faUserSlash,
  faExclamationTriangle,
} from "../../assets/consts/faCharCodes";
export const ROLE_NONE = "none";
const Roles = {
  icons: {
    support: faUserCog,
    admin: faUserTie,
    member: faUser,
    guest: faUserClock,
    none: faUserSlash,
    not_registered: faExclamationTriangle,
    //   none: "user-times"
  },
  colors: {
    support: ArTheme.COLORS.BUTTON_COLOR,
    admin: ArTheme.COLORS.SUCCESS,
    member: ArTheme.COLORS.PRIMARY_DARK,
    guest: ArTheme.COLORS.INFO,
    none: ArTheme.COLORS.MUTED,
    not_registered: ArTheme.COLORS.WARNING,
  },
  bgColors: {
    support: "#9c26b04d",
    admin: "#00ff8c1c",
    member: "#3344a117",
    guest: "#11cdef1f",
    none: "#adb5bd26",
    not_registered: "#fb634029",
  },
};

export default Roles;
